export default "__VITE_ASSET__BRSiy0Lc__"